import { useTheme } from '@mui/material'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const MoneyIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.primary.main
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.6213 7.37864C9.44975 6.20707 7.55025 6.20707 6.37868 7.37864C5.20711 8.55022 5.20711 10.4497 6.37868 11.6213C7.55025 12.7929 9.44975 12.7929 10.6213 11.6213'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle
        cx='8.5'
        cy='9.5'
        r='6'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.13625 2.10867C8.34053 1.71885 7.44582 1.5 6.5 1.5C3.18629 1.5 0.5 4.18629 0.5 7.5C0.5 8.25605 0.639838 8.97944 0.89506 9.64571'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.5 0.5C12.8137 0.5 15.5 3.18629 15.5 6.5'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 8.5H8'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 10.5H8'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
